<template>
  <div class="account">
    <div v-if="!store.getters.isAuthenticated"
         style="text-decoration: underline;"
         @click="openDialog">Login / Sign-up
    </div>

    <div v-else>
      <q-btn-dropdown :label="quasar.screen.xs ? '' : store.getters.user.email"
                      color="black"
                      :dropdown-icon="quasar.screen.xs ? 'fa-solid fa-bars': null"
                      :no-icon-animation="quasar.screen.xs"
                      flat no-caps>
        <q-list>
          <q-item v-if="quasar.screen.xs" class="bg-grey-2">
            <q-item-section>
              <q-item-label class="text-weight-bold" style="color: rgb(39, 170, 225);">
                {{ store.getters.user.email }}
              </q-item-label>
            </q-item-section>
          </q-item>

          <q-separator v-if="quasar.screen.xs"/>

          <q-item v-close-popup :to="{name:'memo-link.list'}" clickable>
            <q-item-section>
              <q-item-label>My Memo.Links</q-item-label>
            </q-item-section>
          </q-item>
          <q-item v-close-popup :to="{name:'subdomains.list'}" clickable>
            <q-item-section>
              <q-item-label>My Domains</q-item-label>
            </q-item-section>
          </q-item>
          <q-item v-close-popup :to="{name:'logout'}" class="text-red-7" clickable>
            <q-item-section>
              <q-item-label>Logout</q-item-label>
            </q-item-section>
          </q-item>

          <q-separator/>

          <q-item v-close-popup :to="{name:'logout',query: { allDevices: true }}" class="text-red-7" clickable>
            <q-item-section>
              <q-item-label>Logout from all devices</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-btn-dropdown>
    </div>
  </div>
</template>

<script setup>
import {useStore} from "vuex";
import {useQuasar} from "quasar";
import { inject } from 'vue'
import LoginDialog from "./dialogs/LoginDialog";

const store = useStore();
const quasar = useQuasar();
const eventBus = inject('eventBus');

function openDialog() {
  quasar.dialog({
    component: LoginDialog,
  });
}

eventBus.on('showLoginDialog',openDialog);
</script>

<style scoped>
div.account {
  text-align: center;
  font-weight: 600;
  cursor: pointer;
  min-width: 10vw;
}
</style>
